class SessionTimerService {
    private sessionTimeoutInMinutes: number;
    private sessionTimer: number | null;
  
    constructor(sessionTimeoutInMinutes: number) {
      this.sessionTimeoutInMinutes = sessionTimeoutInMinutes;
      this.sessionTimer = null;
    }
  
    public startSessionTimer(onTimeout: () => void): void {
      this.resetTimer();
      this.sessionTimer = window.setTimeout(() => {
        onTimeout();
      }, this.sessionTimeoutInMinutes * 60 * 1000);
      
      // Reset the timer when user activity is detected
      const resetTimerOnActivity = () => {
        this.resetTimer();      
        this.sessionTimer = window.setTimeout(() => {
            onTimeout();
          }, this.sessionTimeoutInMinutes * 60 * 1000);
      };
  
      window.addEventListener('mousemove', resetTimerOnActivity);
      window.addEventListener('keydown', resetTimerOnActivity);
      document.addEventListener('click', resetTimerOnActivity);
    }
  
    public stopSessionTimer(): void {
      if (this.sessionTimer) {
        clearTimeout(this.sessionTimer);
        this.sessionTimer = null;
      }
  
      // Remove event listeners
      window.removeEventListener('mousemove', this.resetTimer);
      window.removeEventListener('keydown', this.resetTimer);
      window.removeEventListener('click', this.resetTimer);
    }
  
    private resetTimer(): void {
      if (this.sessionTimer) {
        clearTimeout(this.sessionTimer);
        this.sessionTimer = null;
      }
    }
  }
  
  export default SessionTimerService;